// Google's address components, and the suggestion they came from, into the
// checkout's address fields. Kept out of step3-delivery.jsx so it can be tested
// against what Google really returns (ClickUp 869fhtrvx).

// Same reversed-components parse as legacy's handlePlaceSelected
// (checkout.page.jsx:353-404), including the ZIP+4 suffix.
//
// Google has no `locality` for some places, so the city is looked for in order:
// locality or postal_town, then sublocality_level_1 (the five New York boroughs
// come back as only that: 141 St Edwards St has Brooklyn there and no locality),
// then, in the caller, the city named in the suggestion's own text.
export function parseAddressComponents(components) {
  let street = ''; let zip = ''; let city = ''; let borough = ''; let regionCode = ''; let countryCode = '';
  for (const component of [...components].reverse()) {
    const type = component.types[0];
    if (type === 'street_number') street = `${component.long_name} ${street}`;
    else if (type === 'route') street += component.short_name;
    else if (type === 'postal_code') zip = `${component.long_name}${zip}`;
    else if (type === 'postal_code_suffix') zip += `-${component.long_name}`;
    else if (type === 'locality' || type === 'postal_town') city = component.long_name;
    else if (type === 'sublocality_level_1') borough = component.long_name;
    else if (type === 'administrative_area_level_1') { if (countryCode !== 'GB') regionCode = component.short_name; }
    else if (type === 'country') countryCode = component.short_name;
  }
  return { street: street.trim(), zip, city: city || borough, regionCode, countryCode };
}

// The city a suggestion names, for a place whose components carry none: a street
// that runs through unincorporated land (N 142nd St W, "Colwich, KS, USA") has a
// state, county and ZIP but no locality. The text is "City, ST, Country", so it is
// only trusted when its second part is the state the components gave.
export function cityFromPrediction(prediction, regionCode) {
  const text = (prediction && prediction.secondaryText && prediction.secondaryText.text) || '';
  const parts = text.split(',').map((t) => t.trim());
  if (parts.length < 3 || !regionCode || parts[1].toLowerCase() !== String(regionCode).toLowerCase()) return '';
  return parts[0];
}
